import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/mapaAT/step4';
import { Offres } from '../models/Offres';

@Component({
  selector: 'app-offres',
  templateUrl: './offres.component.html'
})
export class OffresComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() offres : Offres;

  public step4 = new Step4();

  constructor() { }

  public ngOnInit() { }

  getUid() {
    return this.uid + '_SepSep_Offres';
  }
}
